(function (app, ng) {

    addUserController.$inject = ["userRegistrationApi", "$mdDialog", "userApi", "roles", "$state"];
    app.controller("addUserController", addUserController);
    function addUserController(userRegistrationApi, $mdDialog, userApi, roles, $state) {
        var $ctrl = this;

        var errorAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "An error saving has occured.  Please try again.",
            ariaLabel: "Error alert",
            ok: "Close",
            skipHide: true
        });

        ng.extend($ctrl,
            {
                close: close,
                roles: roles,
                addUser: addUser,
                searchEmailAddresses: searchEmailAddresses,
                ui: {}
            });
        $ctrl.isAgentValues = [
            { Label: "Yes", Value: true },
            { Label: "No", Value: false }
        ];
        function searchEmailAddresses(term, addUser) {
            return userApi.searchUserEmailAddresses(term)
                .then(function (result) {
                    if (result) {
                        addUser.emailAddress.$error.emailExists = true;
                    } else {
                        addUser.emailAddress.$error.emailExists = false;
                    }
                });
        }

        function close() { $mdDialog.cancel(); }
        
        function addUser(user, $event) {
            $ctrl.ui.adding = true;
            user.Roles = [user.Role];
            user.ExistingPersonId = null;
            return userRegistrationApi.createUserRegistration(user)
                .then(function (response) {
                    user.Id = response.Id;
                    $mdDialog.hide(user);
                }, function () {
                    $ctrl.ui.adding = false;
                    $mdDialog.show(errorAlert.targetEvent($event));
                });
        }

    }
})(window.app, window.angular); //jshint: ignore:line